import React, { useEffect } from 'react';
import { examenes_item } from '../../json/examenesItem';
import './examenes.css';




const Examenes = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='container examenes-container'>
            <div className='row'>
                <div>
                    <h3 className='title'>Resultado de exámenes de las Personas Consejeras</h3>
                    <hr className='hr-gob' />
                    <h6>La Oficialía Mayor, a través de su Unidad Institucional para la Igualdad entre Mujeres y Hombres, llevó a cabo el proceso de selección de Personas Consejeras.
                        El resultado refleja la elección de personas que cumplieron satisfactoriamente con el perfil, los requisitos y el procedimiento establecido en la Convocatoria, respetando el principio de paridad de género.
                    </h6>
                    <h5>Resultados de evaluación</h5>

                </div>
            </div>
            <div className='row'>
                {
                    examenes_item.map((item, index) => (
                        <div key={index} className='col-md-4 col-sm-6 col-12'>
                            <div className='convocatorias_icono'>
                                <h5>{item.nombre}</h5>
                                <object type="application/pdf" data={item.url} width="250" height="210"></object>
                             </div>
                            <br></br>
                        </div>
                    ))
                }
            </div>    
        </div>
    )
}

export default Examenes